const errorMessages = {
  scheduledFor: 'O horário de agendamento deve ser pelo menos 45 minutos depois do horário atual, volte e verifique.',
};

module.exports.errorMessages = errorMessages;
